import { Engine1Proxy, ConciergeProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import AxiosManager from '../../../Common/Managers/AxiosManager';
import GetApiUrlsHelper from '../../../Common/Helpers/GetApiUrlsHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_MENSAJE_ERROR = "CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_MENSAJE_ERROR";
export const CONTABILIZADORRECONTABILIZADOR_CARGAR_PERMISOS_USUARIO = "CONTABILIZADORRECONTABILIZADOR_CARGAR_PERMISOS_USUARIO";
export const CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_DATOS_EJECUCION = "CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_DATOS_EJECUCION";
export const CONTABILIZADORRECONTABILIZADOR_CAMBIAR_VALOR_COMBO = "CONTABILIZADORRECONTABILIZADOR_CAMBIAR_VALOR_COMBO";
export const CONTABILIZADORRECONTABILIZADOR_CARGA_BARRA_AVANCE = "CONTABILIZADORRECONTABILIZADOR_CARGA_BARRA_AVANCE";
export const CONTABILIZADORRECONTABILIZADOR_CARGA_DATOS_COMBO = "CONTABILIZADORRECONTABILIZADOR_CARGA_DATOS_COMBO";
export const CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER = "CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER";
export const CONTABILIZADORRECONTABILIZADOR_CAMBIAR_CHECK = "CONTABILIZADORRECONTABILIZADOR_CAMBIAR_CHECK";
export const CONTABILIZADORRECONTABILIZADOR_POBLAR_GRILLA_RECONTABILIZADOR = "CONTABILIZADORRECONTABILIZADOR_POBLAR_GRILLA_RECONTABILIZADOR";
export const CONTABILIZADORRECONTABILIZADOR_DESPLEGAR_PROCESOS = "CONTABILIZADORRECONTABILIZADOR_DESPLEGAR_PROCESOS";
export const CONTABILIZADORRECONTABILIZADOR_FILTRAR_MODELOS = "CONTABILIZADORRECONTABILIZADOR_FILTRAR_MODELOS";
export const CONTABILIZADORRECONTABILIZADOR_GUARDAR_QUITAR_MODELO_SELECCIONADO = "CONTABILIZADORRECONTABILIZADOR_GUARDAR_QUITAR_MODELO_SELECCIONADO";
export const CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL_MENSAJE_RESULTADO = "CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL_MENSAJE_RESULTADO"; 
export const CONTABILIZADORRECONTABILIZADOR_INHABILITAR_FECHA_ORIGINAL = "CONTABILIZADORRECONTABILIZADOR_INHABILITAR_FECHA_ORIGINAL";
export const CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL = "CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL";
export const CONTABILIZADORRECONTABILIZADOR_OCULTAR_BOTON_VERMAS = "CONTABILIZADORRECONTABILIZADOR_OCULTAR_BOTON_VERMAS";
export const CONTABILIZADORRECONTABILIZADOR_SELECCIONAR_RB = "CONTABILIZADORRECONTABILIZADOR_SELECCIONAR_RB";
export const CONTABILIZADORRECONTABILIZADOR_PROCESOS_EN_EJECUCION = "CONTABILIZADORRECONTABILIZADOR_PROCESOS_EN_EJECUCION";
export const CONTABILIZADORRECONTABILIZADOR_SETEAR_EJECUCION_LOTE = "CONTABILIZADORRECONTABILIZADOR_SETEAR_EJECUCION_LOTE";

export const INITIAL_STATE = "INITIAL_STATE";

//Definicion de variables globales
let _dispatch = null;
let _getState = null;
let _executionContext = null;

export function primeraCargaContabilizadorRecontabilizador(currentScope, executionContext, fecha) { 
    LogHelper.In(primeraCargaContabilizadorRecontabilizador.name, currentScope, executionContext, fecha);

    return (dispatch,getState) => {
        _dispatch = dispatch;
        _getState = getState;
        _executionContext = executionContext;

        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: true });
        
        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }
        
        ConciergeProxy.Execute((data) => _cargarInformacionPantalla(data), null, "GETFUNCTIONS", currentScopeRequest);

        let paramBarraAvance = {'N_ACCION': _getState().contabilizadorRecontabilizador.radioButtonsContabilizador.contabilizacion}
        let paramCombo = {'ACCION':  _getState().contabilizadorRecontabilizador.radioButtonsContabilizador.contabilizacion}

        let esContabilizacion = paramCombo.ACCION == 0;
       
        Engine1Proxy.AddDataSourcesRequests(paramBarraAvance, 'AD17P_GET_BARRA_AVANCE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramCombo, 'AD17P_MODELOSCONTABLES_GET_DATOS_DETALLE_PROC', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        
        Engine1Proxy.Execute((data) => _cargaDatosPantallaPrincipalContaReconta(data, esContabilizacion),null,  null, "CONTABILIDAD");
        
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: true });

    }

}

function _cargarInformacionPantalla(data) {
    let permisos = [];
    
    data.CONTABILIDAD.forEach(p => { permisos[p.Codigo_Funcion] = true  });
    
    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_CARGAR_PERMISOS_USUARIO, permisos });
}


function _cargaDatosPantallaPrincipalContaReconta(data, esContabilizacion, fechaInput, mostrarUltimaFechaConta) {
    let barraAvance = [];
    let datosCombo = [];

    // - Si "fechaInput" no es null, evaluamos su tipo:
    //    - Si ya es un objeto (presumiblemente un objeto Date), se utiliza directamente.
    //    - Si es un string que contiene el caracter 'T' (indicando fecha con hora), creamos un objeto Date directamente.
    //    - Si es un string sin la 'T', le agregamos 'T00:00:00' para fijar la hora a medianoche y así evitar problemas con la zona horaria al convertir a Date.
    
    let fechaInputValida = fechaInput ? 
                            typeof(fechaInput) == "object" ? 
                                fechaInput : fechaInput.includes('T') ? new Date(fechaInput) : new Date(`${fechaInput}T00:00:00`)
                                : null;
    
    barraAvance = JSON.parse(data.AD17P_GET_BARRA_AVANCE).Recordset0.Rows;
    datosCombo = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_DATOS_DETALLE_PROC).Recordset0.Rows;   

    let fechaMasReciente;
    let objetoMasReciente;
    let objetoEnEjecucion;

    // Recorre la lista de objetos
    if(datosCombo.length) {    
        datosCombo.forEach((objeto) => {
            let fechaInicioStr = objeto.FechaUltimoInicio;
            let fechaFinStr = objeto.FechaUltimoFin;
        
            // Verifica si FechaUltimoInicio está definida y no es null
            if (fechaInicioStr) {                
                // Verifica si FechaUltimoFin está definida y no es null
                const fechaInicio = new Date(fechaInicioStr);
                const fechaFin = new Date(fechaFinStr);
    
                // Compara la fecha de inicio con la fecha de fin
                if (fechaInicio > fechaFin) {
                    // Si FechaUltimoInicio es más reciente que FechaUltimoFin, considera el objeto como en ejecución
                    objetoEnEjecucion = objeto;
                } else if (!fechaMasReciente || fechaFin > fechaMasReciente) {
                    // Si FechaUltimoFin es más reciente que la fecha más reciente registrada, actualiza la fecha más reciente
                    fechaMasReciente = fechaFin;
                    objetoMasReciente = objeto;
                }
            } else {
                // Si no hay FechaUltimoFin, considera el objeto como en ejecución
                objetoEnEjecucion = objeto;
            }
        });
        
        // Si objetoEnEjecucion es más reciente que objetoMasReciente, selecciona objetoEnEjecucion
        if (objetoEnEjecucion && (!objetoMasReciente || objetoEnEjecucion.FechaUltimoInicio > objetoMasReciente.FechaUltimoInicio)) {
            objetoMasReciente = objetoEnEjecucion;
        }
        
        // Si objetoMasReciente sigue siendo undefined, selecciona el primer objeto de la lista
        if (!objetoMasReciente && datosCombo.length > 0) {
            objetoMasReciente = datosCombo[0];
        }

        if (objetoMasReciente && objetoMasReciente.ColorUltimaEjecucion) {
            barraAvance[0].ColorUltimaEjecucion = objetoMasReciente.ColorUltimaEjecucion;
        } else {
            barraAvance.push({
                ColorUltimaEjecucion: null,
                FechaEjecucion: new Date(),
                CantidadProcesosEjecutados: 0,
                CantidadProcesosTotales: datosCombo.length
            });
        }
    }

    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_CARGA_BARRA_AVANCE, barraAvance, esContabilizacion, fechaInput : fechaInputValida , mostrarUltimaFechaConta });
    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_CARGA_DATOS_COMBO, datosCombo });

    if(barraAvance.length)
    {
        let datos = barraAvance[0];

        if(datos)
        {
            let proximoPaso = datos.ProximoPaso;   

            if(datosCombo.length)
            {    
               let procesoCombo = datosCombo.find((reg) => reg.Nombre == proximoPaso);

                _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_CAMBIAR_VALOR_COMBO, nombreCombo:"comboProceso", valorCombo: procesoCombo ? procesoCombo.Nombre : datosCombo[0].Nombre })         
            }

            let param = {
                'FECHA': fechaInput ? fechaInput 
                                    : esContabilizacion ? datos.FechaEjecucion 
                                                        : datos.FechaContabilidadOriginal
            }
        
            Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_MODELOSCONTABLES_GET_DATOS_COMBO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
            Engine1Proxy.Execute((data) => _cargaDatosModelosContables(data, esContabilizacion),null,  null, "CONTABILIDAD");
        } else {
            _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: false });
        }
    } else {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: false });
    }

    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROCESOS_EN_EJECUCION', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);
    Engine1Proxy.Execute((data) => validarProcesosEnEjecucionCallback(data), null, null, 'PROCESOS');
}


function _cargaDatosModelosContables(data, esContabilizacion) {
    if(data.AD17P_MODELOSCONTABLES_GET_DATOS_COMBO) {
        let modelosContablesActivos = [];
        let modelosContables = [];
        let modelosSeleccionados = [];
        let checkTodosModelos = false;

        modelosContablesActivos = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_DATOS_COMBO).Recordset0.Rows;
        modelosContables = modelosContablesActivos;
        modelosSeleccionados = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_DATOS_COMBO).Recordset1.Rows;

        //Si la opción escogida actualmente es una "Re-contabilización" y no se ha recibido datos relacionados a los modelos ejecutados para la fecha seleccionada 
        //(se da por sentado que si no hay datos de modelos recibidos es porque no hubo una contabilización asociada), se inhabilitan los componentes.
        let habilitarEjecucionReconta = !(!esContabilizacion && modelosContablesActivos.length == 0);

        if(modelosSeleccionados.length > 0)
        {
            if(modelosSeleccionados[0].Codigo == null) {
                checkTodosModelos = modelosContables.length > 0;
                modelosSeleccionados = modelosContables;
                modelosContables = [];
            } else {
                modelosContables = modelosContablesActivos.filter((modelo) => {
                                                                                return !modelosSeleccionados.some((modeloSeleccionado) => modeloSeleccionado.Codigo === modelo.Codigo)
                                                                              }
                                                                 );
            }
        }

        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_POBLAR_GRILLA_RECONTABILIZADOR, modelosContablesActivos, modelosContables, modelosSeleccionados, checkTodosModelos, habilitarEjecucionReconta });
    }

    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: false });
}
/*
    ContabilizadorRecontabilizador.jsx
*/
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE });
    }
}

/* SeccionProcesos/RegistroProceso.jsx */
export function mostrarOcultarModalContabilizadorRecontabilizador(nombreModal,mostrarModal, idRegistro) {
    LogHelper.In(mostrarOcultarModalContabilizadorRecontabilizador.name, nombreModal, mostrarModal, idRegistro);

    if(idRegistro) {
        return (dispatch) => {
            _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL, nombreModal, mostrarModal, idRegistro });
        }
    } else {
        return (dispatch) => {
            _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL, nombreModal, mostrarModal });
        }
    }
}

function validarProcesosEnEjecucionCallback(data) {
    let estadoProcesos = JSON.parse(data.GET_PROCESOS_EN_EJECUCION).Recordset0.Rows;

    if (estadoProcesos && estadoProcesos.length > 0 && estadoProcesos[0].EstadoProceso != 0) 
    {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_PROCESOS_EN_EJECUCION, valor: true });

    }else
     {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_PROCESOS_EN_EJECUCION, valor: false });
     }
}

export function validarEjecucionProceso(nombreProceso,esEjecucionGeneral, tipoEjecucion) {
    return (dispatch) => {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL, nombreModal:"modalProceso", mostrarModal: false });
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: true });

        Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROCESOS_EN_EJECUCION', 'Get', 'Tarjetas', 'PROCESOS', null, 'Product', true);

        Engine1Proxy.Execute((data) => validarEjecucionProcesoCallback(data, nombreProceso,esEjecucionGeneral, tipoEjecucion), null, null, 'PROCESOS');
    }
}

function validarEjecucionProcesoCallback(data, nombreProceso, esEjecucionGeneral, tipoEjecucion)  {
    let estadoProcesos = JSON.parse(data.GET_PROCESOS_EN_EJECUCION).Recordset0.Rows;

    let mostrarModal = true;
    let confirmaEjecucion = true;
    let nombreProcesoModal = nombreProceso;
    let procesosEnEjecucion = false;

    if (estadoProcesos && estadoProcesos.length > 0 && estadoProcesos[0].EstadoProceso != 0) {
        mostrarModal = true;
        confirmaEjecucion = false;
        nombreProcesoModal = estadoProcesos[0].Descripcion;
        procesosEnEjecucion = true;
    }

    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL, nombreModal: "modalConfirmacionEjecucion", mostrarModal, confirmaEjecucion, nombreProceso: nombreProcesoModal, esEjecucionGeneral, tipoEjecucion });
    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: false });
    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_PROCESOS_EN_EJECUCION, valor: procesosEnEjecucion });
}


export function ejecucionLoteContabilidad(pasosProcesos, fechaContabilidadOriginal, fechaContabilidadCalendario, modelosContablesSeleccionados, esContabilizacion, pasoInicial, tipoEjecucion){
  
    let barraAvance = _getState().contabilizadorRecontabilizador.barraAvance[0];
    let insertaNuevaEjecucion = false;

    if (!fechaContabilidadOriginal && !fechaContabilidadCalendario)
    {
        fechaContabilidadOriginal = new Date()
        fechaContabilidadCalendario = new Date()
    }

    if (fechaContabilidadCalendario.includes("/")) {
        const partesFecha = fechaContabilidadCalendario.split('/');
        fechaContabilidadCalendario = `${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}`;
    }

    if (!fechaContabilidadOriginal)
    {
        fechaContabilidadOriginal = fechaContabilidadCalendario;
    }

    if (!barraAvance.ColorUltimaEjecucion)
    {
        insertaNuevaEjecucion = true;
    }

    return (dispatch) => {

    let objetoProcesos = {
        PasoInicial: pasoInicial,
        TipoEjecucion: tipoEjecucion,
        EsContabilizacion: esContabilizacion,
        InsertaNuevaEjecucion: insertaNuevaEjecucion,
        FechaContabilidadOriginal: fechaContabilidadOriginal.includes('T') ? new Date(fechaContabilidadCalendario) : new Date(`${fechaContabilidadOriginal}T00:00:00`),
        FechaContabilidadCalendario: new Date(`${fechaContabilidadCalendario}T00:00:00`),
        Login: _executionContext.login,
    }

    let parametros = {
        DATA_PROCESOS: objetoProcesos,
        PROCESOS_CONTAINER: pasosProcesos,
        MODELOS_CONTABLES_CONTAINER: modelosContablesSeleccionados
    };

    Engine1Proxy.AddRuleRequests(parametros, 'EJECUCIONPROCESOSCONTABILIZADORRECONTABILIZADOR', 'Tarjetas', 'CONTABILIDAD');

    Engine1Proxy.Execute((data) => _callbackEjecucionProcesos(data), null, null, "CONTABILIDAD");

    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL, nombreModal: "modalConfirmacionEjecucion", mostrarModal: false});
    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_SETEAR_EJECUCION_LOTE, valor: true});
    
      
 }
}
    function _callbackEjecucionProcesos(result) {

      
        let fechaInputCalendario = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.inputsContabilizadorRecontabilizador.inputFechaContabilidadOriginal));

            if(fechaInputCalendario){

                if (fechaInputCalendario.includes('T')) {

                    fechaInputCalendario = new Date(fechaInputCalendario);

                } else {

                    let partesFecha = fechaInputCalendario.split('/');
                    let dia = parseInt(partesFecha[0], 10);
                    let mes = parseInt(partesFecha[1], 10) - 1; 
                    let anio = parseInt(partesFecha[2], 10);
    
                    fechaInputCalendario = new Date(anio, mes, dia);
                }
            }

        let valorRB = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.radioButtonsContabilizador.contabilizacion));
        let esContabilizacion = valorRB == 0;
        let paramBarraAvance = {'N_ACCION': valorRB}
        let paramCombo = {'ACCION': valorRB }

        let resultado = JSON.parse(result.EJECUCIONPROCESOSCONTABILIZADORRECONTABILIZADOR);

        if(resultado.EsError) {
            _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL, nombreModal: "modalConfirmacionEjecucion", mostrarModal: true, confirmaEjecucion:false, muestraMensajeErrorEjecucion:true, esEjecucionGeneral:false, tipoEjecucion: valorRB });
        }
       
        Engine1Proxy.AddDataSourcesRequests(paramBarraAvance, 'AD17P_GET_BARRA_AVANCE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramCombo, 'AD17P_MODELOSCONTABLES_GET_DATOS_DETALLE_PROC', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

        Engine1Proxy.Execute((data) => _cargaDatosPantallaPrincipalContaReconta(data, esContabilizacion, fechaInputCalendario),null,  null, "CONTABILIDAD"); 
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_SETEAR_EJECUCION_LOTE, valor: false});
    }

export function ejecucionIndividual(nombreProceso,data) {
    return (dispatch) => {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL, nombreModal:"modalConfirmacionEjecucion", mostrarModal: false, confirmaEjecucion: true, nombreProceso: nombreProceso });
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: true });

        let param = null;
        let xmlModelos = null
        let usuario = _executionContext.login;
        let tipoMovimiento = data.datosCombo.find((reg) => reg.Nombre == nombreProceso).TipoMovimiento;
        let valorRadioButton = data.radioButtonsContabilizador.contabilizacion;
        let fechacontabilizacion = data.inputsContabilizadorRecontabilizador.inputFechaContabilidadOriginal.split('/');
        let modelosSeleccionados = data.inputsContabilizadorRecontabilizador.modalSeleccionModelos.modelosContablesSeleccionados;
        let fechaFormateada = `${fechacontabilizacion[2]}-${fechacontabilizacion[1]}-${fechacontabilizacion[0]}`;        

        if(modelosSeleccionados.length != 0)
        {
            xmlModelos = '<Modelos>\n';

            for (var i = 0; i < modelosSeleccionados.length; i++) {    
                xmlModelos += '\t<Modelo Codigo="' + modelosSeleccionados[i].Codigo + '" />\n';                
            }

            xmlModelos += '</Modelos>';
        }

        switch (nombreProceso)
        {
            case "DESCONTABILIZADOR_ASIENTO": {
                param = {
                    'FechaContabilizacion': fechaFormateada,
                    'Usuario': usuario,
                    'CodigosModelos': xmlModelos,
                };

                Engine1Proxy.AddDataSourcesRequests(param, 'UP_DESCONTABILIZADOR_ASIENTO', 'Get', 'Tarjetas', 'CONTABILIDAD', null, 'Product', true);        
            }
            break;

            case "CONSOLIDADOR_ASIENTO": {
                param = {
                    'Recontabilizacion': valorRadioButton, 
                    'Usuario': usuario,
                };

                Engine1Proxy.AddDataSourcesRequests(param, 'UP_CONSOLIDADOR_ASIENTO', 'Get', 'Tarjetas', 'CONTABILIDAD', null, 'Product', true);            
            }
            break;

            default: {
                param = {
                    'FechaContabilizacion': fechaFormateada,
                    'Usuario': usuario,
                    'Recontabilizacion': valorRadioButton, 
                    'TipoMovimientoId': tipoMovimiento,
                    'CodigosModelos': xmlModelos,
                };

                Engine1Proxy.AddDataSourcesRequests(param, 'UP_CONTABILIZADOR_GENERAL', 'Get', 'Tarjetas', 'CONTABILIDAD', null, 'Product', true);
            }
            break;
        } 

        let paramBarraAvance = {'N_ACCION': valorRadioButton}
        let paramCombo = {'ACCION': valorRadioButton}

        Engine1Proxy.AddDataSourcesRequests(paramBarraAvance, 'AD17P_GET_BARRA_AVANCE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramCombo, 'AD17P_MODELOSCONTABLES_GET_DATOS_DETALLE_PROC', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        
        Engine1Proxy.Execute((data) => _cargaDatosPantallaPrincipalContaReconta(data), null,  null, "CONTABILIDAD");
    }
}

export function cambiarValorCombo(nombreCombo, valorCombo) {    
    return (dispatch) => {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_CAMBIAR_VALOR_COMBO, nombreCombo, valorCombo });
    };
}

/* SeccionSuperior.jsx */
export function seleccionarRadioButtonContabilizador(nombreRB, valorRB) {
    LogHelper.In(seleccionarRadioButtonContabilizador.name, nombreRB, valorRB);

    return (dispatch) => {        
        _dispatch ({type: CONTABILIZADORRECONTABILIZADOR_INHABILITAR_FECHA_ORIGINAL, esPrimerPaso: true})
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: true });
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_SELECCIONAR_RB, nombreRB, valorRB });

        let paramBarraAvance = {'N_ACCION': valorRB}
        let paramCombo = {'ACCION': valorRB }

        Engine1Proxy.AddDataSourcesRequests(paramBarraAvance, 'AD17P_GET_BARRA_AVANCE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramCombo, 'AD17P_MODELOSCONTABLES_GET_DATOS_DETALLE_PROC', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

        Engine1Proxy.Execute((data) => _callBackSeleccionRb(data, valorRB),null,  null, "CONTABILIDAD"); 
    };
}

function _callBackSeleccionRb(data, valorRB) {
    let fechaContabilidadOriginal = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.ultimaFechaContabilizacion));;
    let barraAvance = JSON.parse(data.AD17P_GET_BARRA_AVANCE).Recordset0.Rows;
    let esContabilizacion = valorRB == 0;

    if(barraAvance.length > 0) {
        if ((valorRB == 0 && barraAvance[0].ProximoPaso != "UP_Contabilizador_Cobranza") || (valorRB == 1 && barraAvance[0].ProximoPaso != "DESCONTABILIZADOR_ASIENTO" )) {
            _dispatch({type: CONTABILIZADORRECONTABILIZADOR_INHABILITAR_FECHA_ORIGINAL, esPrimerPaso: false})
        }
    }

     _cargaDatosPantallaPrincipalContaReconta(data, esContabilizacion, fechaContabilidadOriginal, true)
}

export function refrescarDatosPantalla() {
    LogHelper.In(refrescarDatosPantalla.name);

    return (dispatch) => {
        let fechaInputCalendario = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.inputsContabilizadorRecontabilizador.inputFechaContabilidadOriginal));

        let partesFecha = fechaInputCalendario.split('/');
        let fechaFormateada = `${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}`;

        let valorRB = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.radioButtonsContabilizador.contabilizacion));
        let esContabilizacion = valorRB == 0;

        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: true });

        let paramBarraAvance = {'N_ACCION': valorRB}
        let paramCombo = {'ACCION': valorRB }

        Engine1Proxy.AddDataSourcesRequests(paramBarraAvance, 'AD17P_GET_BARRA_AVANCE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramCombo, 'AD17P_MODELOSCONTABLES_GET_DATOS_DETALLE_PROC', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

        Engine1Proxy.Execute((data) => _cargaDatosPantallaPrincipalContaReconta(data, esContabilizacion, fechaFormateada),null,  null, "CONTABILIDAD"); 
    };
}

/*
    SeccionProcesos\SeccionProcesos.jsx
*/
export function desplegarProcesos(estaDesplegado) {
    LogHelper.In(desplegarProcesos.name, estaDesplegado);

    return (dispatch) => {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_DESPLEGAR_PROCESOS, estaDesplegado });
    };
}

export function validarInputFecha(fecha) {
    LogHelper.In(validarInputFecha.name, fecha);

    return (dispatch) => {
        let errorValidacion = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.inputsContabilizadorRecontabilizador.errorValidacion));

        let resultadoValidacionFecha = _validarFechaReal(fecha);

        errorValidacion.inputIndicadorFecha = resultadoValidacionFecha;
        
        if(resultadoValidacionFecha) {
            _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_MENSAJE_ERROR, errorValidacion:resultadoValidacionFecha });
        } else {
            let fechaInput = fecha.split('/');
            fechaInput = fechaInput[2] + "-" + fechaInput[1] + "-" + fechaInput[0];

            let paramBarraAvance = {'N_ACCION':  _getState().contabilizadorRecontabilizador.radioButtonsContabilizador.contabilizacion}
            let paramCombo = {'ACCION':  _getState().contabilizadorRecontabilizador.radioButtonsContabilizador.contabilizacion}

            _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: true });
    
            Engine1Proxy.AddDataSourcesRequests(paramBarraAvance, 'AD17P_GET_BARRA_AVANCE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(paramCombo, 'AD17P_MODELOSCONTABLES_GET_DATOS_DETALLE_PROC', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

            Engine1Proxy.Execute((data) => _cargaDatosPantallaPrincipalContaReconta(data, null, fechaInput),null,  null, "CONTABILIDAD");
        }
    }
    
}


/*
    Common\ListaModelosSeleccionados.jsx
*/
export function guardarQuitarModeloSeleccionadoContabilizadorRecontabilizador(modelo, adicionarModelo) {
    LogHelper.In(guardarQuitarModeloSeleccionadoContabilizadorRecontabilizador.name, modelo, adicionarModelo);

    return (dispatch) => {
        let modelos = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.modelosContablesActivos));
        let inputs = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.inputsContabilizadorRecontabilizador));
        let checks = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.checksContabilizador));
        let modeloSeleccionado = modelos.filter(m => {return m.Codigo == modelo})[0];
        let mostrarVerMas = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.mostrarVerMas));


        if (adicionarModelo) {
            inputs.modalSeleccionModelos.modelosContablesSeleccionados.push(modeloSeleccionado);
            inputs.modalSeleccionModelos.modelosContablesFiltrados = inputs.modalSeleccionModelos.modelosContablesFiltrados.filter(m => {return m.Codigo != modelo});

            //Si la longitud del array de modelos seleccionados es igual al de los modelos activos, quiere decir que se seleccionaron todos los modelos, entonces tildo el check de todos los modelos seleccionados
            if(modelos.length == inputs.modalSeleccionModelos.modelosContablesSeleccionados.length) {
                checks.modalSeleccionModelos.checkTodosModelos = true;
            }
        } else {
            if(modelo == "Todos") {
                inputs.modalSeleccionModelos.modelosContablesSeleccionados = [];
                inputs.modalSeleccionModelos.modelosContablesFiltrados = modelos;
            } else {
                inputs.modalSeleccionModelos.modelosContablesSeleccionados = inputs.modalSeleccionModelos.modelosContablesSeleccionados.filter(m => {return m.Codigo != modelo});
                inputs.modalSeleccionModelos.modelosContablesFiltrados.push(modeloSeleccionado);

                mostrarVerMas = !mostrarVerMas ? inputs.modalSeleccionModelos.modelosContablesSeleccionados.length == 8 : mostrarVerMas;
            }

            checks.modalSeleccionModelos.checkTodosModelos = false;
        }
        

        inputs.modalSeleccionModelos.modelosContablesSeleccionados = inputs.modalSeleccionModelos.modelosContablesSeleccionados.sort((a,b) => a.Codigo - b.Codigo);
        inputs.modalSeleccionModelos.modelosContablesFiltrados = inputs.modalSeleccionModelos.modelosContablesFiltrados.sort((a,b) => a.Codigo - b.Codigo);
    
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_GUARDAR_QUITAR_MODELO_SELECCIONADO, inputs, checks, mostrarVerMas });
    }
}


/*
    Modales\ModalSeleccionModelos\BuscadorModelosContables.jsx
*/
export function buscarModelosContables(valorInput) {
    LogHelper.In(buscarModelosContables.name, valorInput);

    return (dispatch) => {
        let modelos = _getState().contabilizadorRecontabilizador.modelosContablesActivos;
        let modelosSeleccionados = _getState().contabilizadorRecontabilizador.inputsContabilizadorRecontabilizador.modalSeleccionModelos.modelosContablesSeleccionados;
        let inputs = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.inputsContabilizadorRecontabilizador));

        inputs.modalSeleccionModelos.modelosContablesFiltrados = busquedaModelosContables(modelos, modelosSeleccionados, valorInput)
        inputs.modalSeleccionModelos.inputBuscadorModelos = valorInput;

        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_FILTRAR_MODELOS, inputs });
    }
}


/*
    Common\ListaModelosSeleccionados.jsx
*/
export function ocultarBotonVerMas() {
    LogHelper.In(ocultarBotonVerMas.name);

    return (dispatch) => {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_OCULTAR_BOTON_VERMAS });
    }
}


/*
    Modales\ModalSeleccionModelos\BuscadorModelosContables.jsx
*/
export function cambiarCheckContabilizadorRecontabilizador(nombreCheck, valorCheck) {
    LogHelper.In(cambiarCheckContabilizadorRecontabilizador.name, nombreCheck, valorCheck);

    return (dispatch) => {
        let checks = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.checksContabilizador));
        let inputs = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.inputsContabilizadorRecontabilizador));
        let modelos = JSON.parse(JSON.stringify(_getState().contabilizadorRecontabilizador.modelosContablesActivos));

        checks.modalSeleccionModelos[nombreCheck] = valorCheck;

        if(valorCheck) {
            inputs.modalSeleccionModelos.modelosContablesFiltrados = [];
            inputs.modalSeleccionModelos.modelosContablesSeleccionados = modelos;
        } else {
            inputs.modalSeleccionModelos.modelosContablesFiltrados = modelos;
            inputs.modalSeleccionModelos.modelosContablesSeleccionados = [];
        }

        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_CAMBIAR_CHECK, checks, inputs });
    }
}

export function cargarRegistrosDatosEjecucion(idTraza) {
    LogHelper.In(cargarRegistrosDatosEjecucion.name, idTraza);

    return (dispatch) => {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: true });
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL, nombreModal: "modalProceso", mostrarModal: false, idRegistro: idTraza });

        let param = {
            'PROCESO_TRAZA_ID': idTraza
        }

        Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_CONTABILIZADOR_GET_LOG_PROCESO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
       
        Engine1Proxy.Execute((data) => _callBackCargarRegistroEjecucionNota(data),null,  null, "CONTABILIDAD");
    }
}

function _callBackCargarRegistroEjecucionNota(data){
    let idRegistro = _getState().contabilizadorRecontabilizador.idRegistro;
    
    let registroEjecucionCabecera = [];
    let registroEjecucionDetalle = [];
    
    registroEjecucionCabecera = JSON.parse(data.AD17P_CONTABILIZADOR_GET_LOG_PROCESO).Recordset0.Rows;
    registroEjecucionDetalle = JSON.parse(data.AD17P_CONTABILIZADOR_GET_LOG_PROCESO).Recordset1.Rows;


    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_DATOS_EJECUCION, registroEjecucionCabecera, registroEjecucionDetalle });
    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: false }); 
    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL, nombreModal: "modalProceso", mostrarModal: true, idRegistro });
}

export function descargarExcel(registroEjecucionDetalle, datosRegistroSeleccionado) {
    return (dispatch) => {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: true });

        let fechaActual = formatearFecha(new Date().toLocaleDateString('en-GB'));
        let nombreArchivo = fechaActual + "_dataContabilizacion.xlsx";
        let nombreHoja = "Notas Contabilidad";
        let ultimoPuntoIndex = datosRegistroSeleccionado.Descripcion.lastIndexOf('.');
        let textoDespuesDelPunto = "";

        if (ultimoPuntoIndex !== -1) {
            textoDespuesDelPunto = datosRegistroSeleccionado.Descripcion.substring(ultimoPuntoIndex + 1).trim();
        }

        let params = {
            FileConfigName: "ContabilizadorRecontabilizador_Excel",            
            ExcelBody: [
                {
                    SheetName: nombreHoja,
                    Content: {
                        ContabilizadorRecontabilizadorContent: registroEjecucionDetalle
                    }
                }
            ],
            FileName: nombreArchivo,
            ReportTitle: "Notas del procesamiento de " + textoDespuesDelPunto
        };

        AxiosManager.AxiosRequest('post', GetApiUrlsHelper.GetAxiosUrl('ExcelFile'), null, params, 'arraybuffer', _callbackFileDownload, _callbackMostrarMensajeError)
    };
}

function _callbackFileDownload(response) {
    try {
        if(response) {
            const nombreArchivo = JSON.parse(response.config.data)?.FileName;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', nombreArchivo);
            document.body.appendChild(link);
            link.click();

            _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: false });
        }
    } catch (error) {
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: false });
        _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: "Ocurrió un error al intentar descargar el archivo. Información: " + error, redireccionarPantallaPrincipal: false });
    }
}

function _callbackMostrarMensajeError(response) {
    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER, valor: false });
    _dispatch({ type: CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: "Ocurrió un error al intentar descargar el archivo. Información: " + response, redireccionarPantallaPrincipal: false });
}

/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++FUNCIONES AUXILIARES++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
function busquedaModelosContables(modelos, modelosSeleccionados, input) {
    if(modelosSeleccionados.length > 0) {
        //Se quitan los modelos que ya fueron seleccionados
        modelos = modelos.filter(m => { return !modelosSeleccionados.some(ms => ms.Codigo == m.Codigo) });
    }

    return filtrarModelos(modelos, input);
}


function filtrarModelos(modelos, valorInput) {
    let modelosFiltradosBuscador = [];

    if(valorInput){
        let modelosFiltradosCodigo = modelos.filter( function(m) {
            let modelosFiltrados = m["Codigo"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

        let modelosFiltradosDescripcion = modelos.filter( function(m) {
            let modelosFiltrados = m["Descripcion"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

         let modelosMergeados = [...modelosFiltradosCodigo, ...modelosFiltradosDescripcion];

         modelosFiltradosBuscador = [... new Set(modelosMergeados)];
    }
    else {
        modelosFiltradosBuscador = modelos;
    }

    return modelosFiltradosBuscador;
}

//Funcion para validar y formatear que la fecha exista en el calendario
function _validarFechaReal(fecha) {
    if (fecha && fecha != "Fecha inválida") {
        let fechaf = fecha.split("/");
        let d = fechaf[0];
        let m = fechaf[1];
        let a = fechaf[2];

        let result = m > 0 && m < 13 && a > 0 && a < 32768 && d > 0 && d <= (new Date(a, m, 0)).getDate();

        if (result) {
            let fechaActual = new Date();
            let fechaIngresada = new Date(a, m - 1, d);
            result = fechaIngresada <= fechaActual;
            if (!result) {
                return "La fecha ingresada no puede ser mayor a la fecha actual";
            }
        }        

        return result ? "" : "Fecha inválida";
    } else {
        let resultado = fecha ? fecha : "Ingresar una fecha";

        return resultado;
    }
}
function formatearFecha(fecha) {
    let diaFecha = fecha.substring(0,2);
    let mesFecha = fecha.substring(3,5);
    let anioFecha = fecha.substring(6,10);

    return anioFecha + mesFecha + diaFecha;
}